export const orderStatus = {
    CREATED: 'CREATED',
    FULFILLED: 'FULFILLED',
    PAYED: 'PAYED',
    ERROR: 'ERROR',
}
